import React, { useState } from 'react';
import { Form, Formik } from 'formik';
import SelectFormik from '../../Common/Formik/Select';
import Label from '../../Common/Formik/Label';
import tipoDePropiedadMap from '../../../Models/TipoDePropiedad';

const TipoPropiedad = ({ setTipoPropiedadSelected, tipoPropiedadSelected, setSeleccionCountry }) => {
    const handleChange = (e) => {
        if(e.target.value !== 'country'){
            setSeleccionCountry(null);
        }
        setTipoPropiedadSelected(e.target.value);
    };

    return (
        <>
            <Formik
                initialValues={{
                    tipoDePropiedad: tipoPropiedadSelected
                        ? tipoPropiedadSelected
                        : 'casa',
                }}
                enableReinitialize
            >
                {() => (
                    <Form noValidate>
                        <div className="--mb-24">
                            <Label text={'Tipo de propiedad'} />
                            <SelectFormik
                                handleChange={(e) => handleChange(e)}
                                // disabled={!!selectedCountry && !isFirstStep}
                                name="tipoDePropiedad"
                            >
                                {tipoDePropiedadMap.map((tipoDePropiedad) => {
                                    return (
                                        <option
                                            value={tipoDePropiedad.id}
                                            key={tipoDePropiedad.id}
                                        >
                                            {tipoDePropiedad.descripcion}
                                        </option>
                                    );
                                })}
                            </SelectFormik>
                        </div>
                    </Form>
                )}
            </Formik>
        </>
    );
};

export default TipoPropiedad;
